<!--Copyright (C) nexleader - All Rights Reserved-->
<!--Unauthorized copying of this file, via any medium is strictly prohibited-->
<!--Proprietary and confidential-->
<!--Written for nexleader <myipsat.com>, 2016-2026-->

<div class="modal-header">
  <h3 class="modal-title">{{ headerTitle }}</h3>
  <button type="button" class="close" aria-label="Close" (click)="close()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body" *ngIf="rows.length > 0">
  <p class="text-muted m-b-md">
    Understanding how your {{ primaryArchetypeName }} pattern interacts with each of the other five archetypes
    helps you balance contribution with growth across relationships and teams.
  </p>

  <!-- Rich AI-personalized cards (preferred) -->
  <div *ngIf="hasRichRows">
    <div *ngFor="let row of rows; let i = index" class="m-b-lg">
      <h4 class="font-bold m-b-xs">
        {{ i + 1 }}. With {{ row.archetypeName }}s
        <span class="text-primary-2" *ngIf="row.rich?.title">— {{ row.rich?.title }}</span>
      </h4>
      <p class="m-b-sm" *ngIf="row.rich?.dynamic">{{ row.rich?.dynamic }}</p>
      <p class="m-b-xs" *ngIf="row.rich?.best_practices">
        <strong>Best Practices:</strong> {{ row.rich?.best_practices }}
      </p>
      <p class="m-b-xs font-italic" *ngIf="row.rich?.example">
        <strong>Example:</strong> &ldquo;{{ row.rich?.example }}&rdquo;
      </p>
      <p class="m-b-none" *ngIf="row.rich?.for_user">
        <strong>For {{ userFirstName || 'You' }}:</strong> {{ row.rich?.for_user }}
      </p>
      <p class="m-b-none" *ngIf="!row.rich && row.description">
        {{ row.description }}
      </p>
    </div>
  </div>

  <!-- Legacy single-line fallback (pre-prompt-7 reports) -->
  <table class="table table-striped" *ngIf="!hasRichRows">
    <thead>
      <tr>
        <th style="width: 35%;">Paired With</th>
        <th>What This Pairing Tends to Do</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of rows">
        <td><strong>{{ row.archetypeName }}</strong></td>
        <td>{{ row.description }}</td>
      </tr>
    </tbody>
  </table>
</div>

<div class="modal-body" *ngIf="rows.length === 0">
  <p class="text-muted text-center m-t-md m-b-md">
    No interaction content available for this archetype.
  </p>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-success" (click)="close()">Close</button>
</div>
